var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.row.file_url)?_c('a',{staticClass:"ml-4 cursor-pointer yx-color-primary",attrs:{"href":_vm.row.file_url}},[_vm._v("导出失败数据")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }